import React from "react";
import { connect } from "react-redux";
import { Polygon, useMapsLibrary } from "@vis.gl/react-google-maps/dist/index.umd.js";

export const Poligono = ({
  onEditandoPoligono,
  onMouseOverChange,
  onClick,
  coordenadas,
  coordenadasEditando,
  pastoSelecionado,
  pasto,
  raised,
  highlight,
  block,
  destacarModulo,
  corLinha,
  cor,
  editando,
  fillOpacity,
  strokeWeight,
}) => {

  const geometryLibrary = useMapsLibrary("geometry");

  const EditandoPoligono = (paths) => {
    const primeiraRota = Array.isArray(paths) && Array.isArray(paths[0]) ? paths[0] : paths;

    const area = geometryLibrary && primeiraRota.length > 0
      ? (geometryLibrary.spherical.computeArea(primeiraRota) / 10000).toFixed(1)
      : 0;

    const coordenadas = primeiraRota.map((path) => ({
      lat: typeof path.lat === "function" ? path.lat() : path.lat,
      lng: typeof path.lng === "function" ? path.lng() : path.lng,
    }));

    onEditandoPoligono(coordenadas, area);
  };


  const coordenadasPasto =
    pasto && pasto.IdPasto === pastoSelecionado.IdPasto
      ? coordenadasEditando && coordenadasEditando.length > 0
        ? coordenadasEditando
        : coordenadas
      : coordenadas;

  const fillOpacityPasto =
    typeof fillOpacity === "number"
      ? fillOpacity
      : highlight
        ? 1.0
        : block
          ? 0.2
          : destacarModulo
            ? 0.6
            : 0.5;

  const strokeWeightPasto =
    typeof strokeWeight === "number"
      ? strokeWeight
      : corLinha && destacarModulo
        ? 3.2
        : 0.6;

  return (
    <Polygon
      onMouseOver={() => {
        onMouseOverChange && onMouseOverChange(true);
      }}
      onMouseOut={() => {
        onMouseOverChange && onMouseOverChange(false);
      }}
      onClick={(e) => onClick && onClick(e)}
      paths={coordenadasPasto}
      options={{
        editable: editando ? editando : false,
        zIndex: raised ? 3 : -3,
        fillOpacity: fillOpacityPasto,
        strokeColor: corLinha || "#000000",
        strokeOpacity: corLinha ? 1 : 0.4,
        strokeWeight: strokeWeightPasto,
        fillColor: cor,

      }}
      draggable={false}
      editable={editando ? editando : false}
      onPathsChanged={(paths) => {
        if (!editando) {
          return;
        }

        EditandoPoligono(paths);
      }}

    />
  );

}
export default connect(null, null)(Poligono);
